<template>
  <v-container>
    <div>
      <v-row justify="space-between">
        <v-col cols="12" sm="6" justify="center">
          <p class="header-title"> {{ $t('menu.staff_assign') }} </p>
        </v-col>

        <v-col cols="12" sm="6">
          <div class="d-flex flex-row-reverse">
            <!--            <v-btn color="primary" dark @click="get">{{ $t('common.refresh')}}</v-btn>-->
          </div>
        </v-col>
      </v-row>
    </div>
    <v-data-table :headers="headers" :items="desserts" :search="search" class="elevation-1" hide-default-footer
                  :page.sync="page" :loading="loading" :items-per-page="itemsPerPage" @page-count="pageCount = $event">
      <template v-slot:top>
        <!-- <div>
            <p class="header-title pt-5 pl-5"> {{$t('staff_management.title')}} </p>
        </div> -->
        <!-- <v-container align="center"> -->
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name"
                              v-bind:label="$t('location_assign.select_province')" return-object outlined
                              dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectDistrict" :items="districts" item-text="district_name"
                              v-bind:label="$t('location_assign.select_district')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="7">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-toolbar>

      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-btn color="primary" @click="showAssignSale(item)" :disabled="checkDisableAssign(item)">
          {{ $t('location_assign.sale_assign') }}
        </v-btn>
      </template>

      <template v-slot:[`item.vtProvince`]="{ item }">
        <span class="contentName">
            {{ item.vtProvince ? item.vtProvince.province_name : '' }}
        </span>
      </template>

      <template v-slot:[`item.vtDistrict`]="{ item }">
        <span class="contentName">
            {{ item.vtDistrict ? item.vtDistrict.district_name : '' }}
        </span>
      </template>

      <template v-slot:[`item.sale`]="{ item }">
        <div class="contentAddress" v-if="item.sale">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.sale.fullname + ' (' + item.sale.job.context.parents[1].name + "/" + item.sale.job.context.name + ')'}}
            </span>
          </v-tooltip>
          <span>
                {{ item.sale.nickname }}
          </span>
        </div>
        <div class="contentAddress" v-else>
          <span>
                {{ $t('order_unit.unassign') }}
          </span>
        </div>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <v-dialog v-model="dialog" max-width="60%" persistent>
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="headline" primary-title>
          {{ $t('location_assign.select_team') }}
        </v-card-title>

        <v-card-text>
          <div class="text-center mt-5">
            <v-autocomplete v-model="selectDepartment" :items="departments" item-text="name"
                            v-bind:label="$t('location_assign.select_department')" filled outlined return-object>
            </v-autocomplete>

            <v-autocomplete v-model="selectTeam" :items="teams" item-text="name"
                            v-bind:label="$t('location_assign.select_team')" filled outlined return-object>
            </v-autocomplete>

            <v-autocomplete v-model="selectStaff" :items="staffs" item-text="displayName"
                            v-bind:label="$t('location_assign.select_sale')" filled outlined return-object>
            </v-autocomplete>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn color="primary" @click="closeAssign">
            {{ $t('common.cancel') }}
          </v-btn>

          <v-btn color="primary" @click="assignSale">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    show: false,
    e1: 0,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    isEdit: false,

    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    modal: false,

    firstEdit: true,
    search: '',
    dialog: false,

    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index'},
      {text: i18n.t('order_unit.name'), value: 'name'},
      {text: i18n.t('order_unit.province_display'), value: 'vtProvince'},
      {text: '', sortable: false, value: 'vtProvince.province_name', align: ' d-none'},
      {text: i18n.t('order_unit.district_display'), value: 'vtDistrict'},
      {text: '', sortable: false, value: 'vtProvince.district_name', align: ' d-none'},

      {text: i18n.t('order_unit.sale_assign'), value: 'sale'},
      {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},

      {text: '', value: 'action', sortable: false}
    ],

    desserts: [],
    fullStaff: [],
    editedIndex: -1,
    editedItem: null,
    defaultItem: {},

    selectDepartment: null,
    departments: [],

    selectTeam: null,
    teams: [],

    selectStaff: null,
    staffs: [],

    provinces: [],
    selectProvince: {},

    selectDistrict: null,
    districts: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('staff_management.add_management') : i18n.t('staff_management.edit_management')
    },

    computedDateFormatted() {
      return this.formatDate(this.date)
    },
  },

  components: {},

  watch: {
    selectDepartment(val) {
      if (val) {
        this.getTeamByDepartmentId(val._id);
      }
    },

    selectTeam(val) {
      this.filterStaff(val);
    },

    selectProvince(val) {
      if (val) {
        this.getDistrictByProvinceID(val.province_id);
      }
    },

    selectDistrict(val) {
      if (val) {
        this.getOrderUnitByDistrict(val._id);
      }
    },
  },

  async created() {
    await this.getProvince();
    await this.getDepartment();
    await this.getUser();
  },

  async mounted() {

  },

  methods: {
    initialize() {
    },

    formatDate(date) {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    async showAssignSale(item) {
      const self = this;
      self.editedIndex = self.desserts.indexOf(item)
      self.editedItem = item;

      if (self.editedItem.sale) {
        const sale = self.editedItem.sale;
        sale.displayName = this.$formatDisplayName(sale);
        const context = sale.job.context;
        self.selectDepartment = context.parents[1];
        self.selectTeam = context;
        self.selectStaff = sale;
      } else {
        if (this.departments.length > 0) {
          this.selectDepartment = this.departments[0];
        }

        if (this.teams.length > 0) {
          this.selectTeam = this.teams[0];
          this.filterStaff(this.selectTeam);
        }
      }

      self.dialog = true;
    },

    closeAssign() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1;
      this.selectStaff = null;
      this.selectTeam = null;
    },

    async getOrderUnitByDistrict(districtId) {
      this.desserts = await this.$getAllOrderUnitByDistrict(districtId);
      this.desserts.forEach((item, index) => item.index = index + 1);
      this.loading = false;
    },

    async assignSale() {
      if (!this.selectStaff || !this.selectStaff._id) {
        alert(i18n.t('validate.infor_empty'));
        return;
      }
      const self = this;
      const requestBody = {
        sale: self.selectStaff
      }

      try {
        const response = await this.$http.put(process.env.VUE_APP_ORDER_UNIT_API + self.editedItem._id, requestBody);

        if (response.data && response.data.success) {
          self.editedItem.sale = self.selectStaff;
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
        } else if (response.data && !response.data.success) {
          alert(i18n.t(response.data.message));
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } catch (e) {
        console.log(e.stack);
        alert(i18n.t('validate.request_error'));
      }

      self.closeAssign();
    },

    checkDisableAssign(item) {
      if (this.$isAdmin || this.$getUserCategory >= 4) {
        return false;
      } else {
        if (this.$getUserCategory === 3 && item.sale && item.sale.job.context.parents[1]._id !== this.$getUserContextID ) {
          return true;
        }
        // if (this.$getUserCategory === 2 && item.sale && item.sale.job.context._id !== this.$getUserContextID ) {
        //   return true;
        // }

        return false;
      }
    },

    async getUser() {
      const userId = localStorage.getItem("user_id");

      try {
        let url;
        if (this.isAdmin) {
          url = '/user/context/5df4859b3538a45b0a15c920?status=1'
        } else {
          url = process.env.VUE_APP_GET_USER_CONTEXT_URL + '?status=1'
        }
        const response = await this.$http.get(url);
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.fullStaff = contextArr.filter(item => item._id !== userId);
          this.fullStaff.forEach(user => {
            user.displayName = this.$formatDisplayName(user);
          })
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    filterStaff(team) {
      if (!this.fullStaff || this.fullStaff.length == 0) {
        return;
      }

      this.staffs = [].concat(this.fullStaff);

      let tempDataArray = [];
      if (this.selectTeam && this.selectTeam._id != -1) {
        this.staffs.forEach(item => {
          const job = item.job;
          if (job.context) {
            if (job.context._id === team._id) {
              tempDataArray.push(item);
            }
          }
        })

        this.staffs = [].concat(tempDataArray);
        if (this.staffs.length > 0 && !this.selectStaff) {
          this.selectStaff = this.staffs[0];
        }
      }
    },

    async getDepartment() {
      if (this.$isAdmin) {
        this.departments = await this.$getAllDepartmentOfSale();
      } else {
        if (this.$getUserCategory === 3 ) {
          const data = await this.$getDetailContext(this.$getUserContextID);
          this.departments = [].concat(data);
        } else if (this.$getUserCategory === 2 ) {
          const data = await this.$getDetailContext(this.$getUserContextID);
          this.departments = [].concat(data.parents[1]);
          this.teams = [].concat(data);
        }
      }

      if (this.departments.length > 0) {
        this.selectDepartment = this.departments[0];
      }
    },

    async getTeamByDepartmentId(departmentId) {
      if (this.$isAdmin || this.$getUserCategory === 3) {
        this.teams = await this.$getTeamByDepartment(departmentId);
      }

      if (this.teams.length > 0) {
        this.selectTeam = this.teams[0];
      }
    },

    async getProvince() {
      if (this.$isAdmin) {
        this.provinces = await this.$getAllProvinces();

      } else {
        if (this.$getUserCategory === 3 ) {
          this.provinces = await this.$getProvincesByContext(this.$getUserContextID);
          if (this.provinces.length > 0) {
            this.selectProvince = this.provinces[0];
          }
        } else if (this.$getUserCategory === 2 ) {
          const data = await this.$getDetailContext(this.$getUserContextID);
          const contextDepartment = data.parents[1];

          this.provinces = await this.$getProvincesByContext(contextDepartment._id);
        }
      }

      if (this.provinces.length > 0) {
        this.selectProvince = this.provinces[0];
      }
    },

    async getDistrictByProvinceID(provinceId) {
      if (this.$isAdmin || this.$getUserCategory === 3) {
        this.districts = await this.$getDistrictByProvince(provinceId);
        if (this.districts.length > 0) {
          this.selectDistrict = this.districts[0];
        }
      } else {
        this.districts = await this.$getDistrictByContext(this.$getUserContextID, this.selectProvince.province_id);

        if (this.districts.length > 0) {
          this.selectDistrict = this.districts[0];
        }
      }
    },
  },
}
</script>

<style scoped>

.v-text-field .v-input__control .v-input__slot {
  min-height: 45px !important;
  /* display: flex !important; */
  align-items: center !important;
}
</style>
